module.exports = __webpack_public_path__ + "img/hub-agendamento.f69a17ae.png";